module.exports = __webpack_public_path__ + "img/paystack.cfaf3136.png";